import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { Product } from '../../entities/Product';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [filterValues, setFilterValues] = useState({ categoryId: null });
  const [count, setCount] = useState(0);
  const [isFiltered, setFiltered] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const getProducts = async (count = 8, offset = 0) => {
    await apiRequests.products.get(count, offset).then((res) => {
      setProducts(res.items);
      setCount(res.totalCount);
    });
  };

  useEffect(() => {
    const getData = () => {
      const isFiltersExist = searchParams.get('categoryId');
      if (isFiltersExist) {
        setFilterValues({ categoryId: isFiltersExist });
        apiRequests.products.filter(100, 0, undefined, isFiltersExist).then((res) => setProducts(res.items));
      } else {
        // getProducts()
      }
      apiRequests.products.getCategories().then((res) => setCategories(res.items));
    };
    getData();
  }, []);

  const handleSearch = () => {
    if (searchValue === '') {
      getProducts();
      setFiltered(false);
    } else {
      apiRequests.products.filter(100, 0, searchValue).then((res) => {
        setProducts(res.items);
        setFiltered(true);
      });
    }
  };

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const applyFilters = () => {
    setSearchParams((prev) => {
      if (filterValues.categoryId) {
        prev.set('categoryId', filterValues.categoryId);
      } else {
        prev.delete('categoryId');
      }
      return prev;
    });
    if (filterValues.categoryId) {
      apiRequests.products.filter(100, 0, undefined, filterValues.categoryId).then((res) => {
        setProducts(res.items);
        setFiltered(true);
      });
    } else {
      getProducts();
      setFiltered(false);
    }
  };

  const resetFilters = () => {
    setFilterValues({ categoryId: null });
    setSearchParams({});
    getProducts();
    setFiltered(false);
  };

  const filters = [
    {
      key: 'categoryId',
      type: 'select',
      label: 'Категория',
      value: filterValues.categoryId,
      placeholder: 'Все категории',
      options: categories?.map((c) => ({ value: c.id, label: c.title })) || [],
    },
  ];

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск товаров..."
        filters={filters}
        onFilterChange={handleFilterChange}
        onApplyFilters={applyFilters}
        onResetFilters={resetFilters}
        createLink={`${location.pathname}/create`}
      />

      <div className="page-goods mb-3">
        <div className="row">
          {products.length === 0 ? (
            <p className={'text-center'}>По вашему запросу ничего не найдено</p>
          ) : (
            products.map((i) => (
              <Product
                key={i.id}
                deleteHandler={(id) => setProducts((prev) => prev.filter((i) => i.id !== id))}
                data={i}
              />
            ))
          )}
        </div>
      </div>
      {!isFiltered && (
        <Pagination count={count} itemsPerPage={8} onChange={(page) => getProducts(8, page * 8)} />
      )}
    </>
  );
};

export default ProductsPage;
